/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ComputePriceRange,
  ComputePriceRange$inboundSchema,
  ComputePriceRange$Outbound,
  ComputePriceRange$outboundSchema,
} from "./computepricerange.js";

export type ComputeProviderQuote = {
  available: boolean;
  priceUsdHr: ComputePriceRange | null;
  /**
   * Opaque compute-provider identifier. Supported values are deployment-specific.
   */
  provider: string;
};

/** @internal */
export const ComputeProviderQuote$inboundSchema: z.ZodType<
  ComputeProviderQuote,
  z.ZodTypeDef,
  unknown
> = z.object({
  available: z.boolean(),
  price_usd_hr: z.nullable(ComputePriceRange$inboundSchema),
  provider: z.string(),
}).transform((v) => {
  return remap$(v, {
    "price_usd_hr": "priceUsdHr",
  });
});
/** @internal */
export type ComputeProviderQuote$Outbound = {
  available: boolean;
  price_usd_hr: ComputePriceRange$Outbound | null;
  provider: string;
};

/** @internal */
export const ComputeProviderQuote$outboundSchema: z.ZodType<
  ComputeProviderQuote$Outbound,
  z.ZodTypeDef,
  ComputeProviderQuote
> = z.object({
  available: z.boolean(),
  priceUsdHr: z.nullable(ComputePriceRange$outboundSchema),
  provider: z.string(),
}).transform((v) => {
  return remap$(v, {
    priceUsdHr: "price_usd_hr",
  });
});

export function computeProviderQuoteToJSON(
  computeProviderQuote: ComputeProviderQuote,
): string {
  return JSON.stringify(
    ComputeProviderQuote$outboundSchema.parse(computeProviderQuote),
  );
}
export function computeProviderQuoteFromJSON(
  jsonString: string,
): SafeParseResult<ComputeProviderQuote, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeProviderQuote$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeProviderQuote' from JSON`,
  );
}
